module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table class="datatable">\n    <thead>\n        <tr>\n            <th>Name</th>\n            <th>Joinos Code</th>\n            <th>Creation Date</th>\n            <th>Expiry Date</th>\n            <th>Class</th>\n            <th>Year</th>\n            <th>Reg</th>\n            <th>Letter</th>\n            <th>Cancel</th>\n        </tr>\n    </thead>\n    <tbody>\n\n    </tbody>\n</table>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./joinos_codes/templates/list.html
// module id = 311
// module chunks = 0